import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'round'
})
export class RoundPipe implements PipeTransform {

  transform(value: number): number {
    return Math.round(value);
}

}


@Pipe({
  name: 'sort',
  pure: false
})
export class ArraySortPipe implements PipeTransform {

  transform(array: Array<string>, args: string): Array<string> {

    if(!array || array === undefined || array.length === 0) return null;
  
      array.sort((a: any, b: any) => {
        if (a.date < b.date) {
          return -1;
        } else if (a.date > b.date) {
          return 1;
        } else {
          return 0;
        }
      });
      return array;
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/round.pipe.ts